import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WarrantyCard = ({ warranty, onCreateSAV }) => {
  const calculateDaysLeft = (expirationDate) => {
    const expiration = new Date(expirationDate);
    const today = new Date();
    const daysLeft = Math.ceil((expiration - today) / (1000 * 60 * 60 * 24));
    return daysLeft > 0 ? daysLeft : 0;
  };

  const getWarrantyStatus = (expirationDate) => {
    const daysLeft = calculateDaysLeft(expirationDate);
    if (daysLeft === 0) return { label: 'Expirée', color: 'bg-error/10 text-error' };
    if (daysLeft <= 30) return { label: 'Expire bientôt', color: 'bg-warning/10 text-warning' };
    return { label: 'Active', color: 'bg-success/10 text-success' };
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric'
    });
  };

  const status = getWarrantyStatus(warranty?.expirationDate);
  const daysLeft = calculateDaysLeft(warranty?.expirationDate);

  return (
    <div className="bg-card rounded-lg border border-border p-4 lg:p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-success/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Shield" size={20} color="var(--color-success)" />
          </div>
          <div>
            <h3 className="text-base font-semibold text-foreground mb-1">
              {warranty?.serviceName}
            </h3>
            <p className="text-sm text-muted-foreground">
              Référence: {warranty?.reference}
            </p>
          </div>
        </div>
        
        <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${status?.color}`}>
          <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
          {status?.label}
        </span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Date d'intervention</p>
          <p className="text-sm font-medium text-foreground">{formatDate(warranty?.serviceDate)}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Expiration de la garantie</p>
          <p className="text-sm font-medium text-foreground">{formatDate(warranty?.expirationDate)}</p>
        </div>
      </div>
      {daysLeft > 0 && (
        <div className="mb-4 p-3 bg-muted rounded-lg">
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Temps restant</span>
            <span className="text-lg font-bold text-foreground">{daysLeft} jours</span>
          </div>
          <div className="mt-2 h-2 bg-background rounded-full overflow-hidden">
            <div 
              className="h-full bg-success rounded-full transition-all"
              style={{ width: `${Math.min((daysLeft / 180) * 100, 100)}%` }}
            ></div>
          </div>
        </div>
      )}
      <div className="space-y-2 mb-4">
        <p className="text-xs text-muted-foreground">Couverture de la garantie:</p>
        <ul className="space-y-1">
          {warranty?.coverage?.map((item, index) => (
            <li key={index} className="flex items-start gap-2 text-sm text-foreground">
              <Icon name="Check" size={16} className="text-success flex-shrink-0 mt-0.5" />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
      {daysLeft > 0 && (
        <Button
          variant="outline"
          size="sm"
          iconName="AlertCircle"
          iconPosition="left"
          fullWidth
          onClick={() => onCreateSAV(warranty?.id)}
        >
          Créer un ticket SAV
        </Button>
      )}
    </div>
  );
};

export default WarrantyCard;